<!--
 * @Description: 互动解锁组件
 * @Author: dezhi
 * @Date: 2019-08-09 13:47:18
 * @LastEditTime: 2020-11-18 09:41:40
 * @LastEditors: dezhi
 -->
<template>
  <section>
    <a-row>
      <a-col :span="12">
        <h3>准 考 证</h3>
        <table>
          <tr>
            <td>报考证书</td>
            <td colspan="2">{{ examInfo.certificationName }}</td>
          </tr>
          <tr>
            <td>评定科目</td>
            <td colspan="2">{{ examInfo.subject }}</td>
          </tr>
          <tr>
            <td>评定时间</td>
            <td colspan="2">{{ examInfo.examStartdate }}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>准考证号</td>
            <td>{{ examInfo.admissionNo }}</td>
            <td rowspan="5" style="position: relative">
              <img :src="examInfo.enrollImageURL" width="180" />
              <img
                class="seal"
                v-if="isAc"
                src="@/assets/images/fai.jpg"
                width="160"
              />
            </td>
          </tr>
          <tr>
            <td>姓名</td>
            <td>{{ examInfo.idname }}</td>
          </tr>
          <tr>
            <td>性别</td>
            <td>{{ examInfo.gender }}</td>
          </tr>
          <tr>
            <td>证件类型</td>
            <td>{{ type[examInfo.idpaperType - 1] }}</td>
          </tr>
          <tr>
            <td>证件号码</td>
            <td>{{ examInfo.idno }}</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>考点</td>
            <td colspan="2">{{ examInfo.areaName }}</td>
          </tr>
          <tr>
            <td>试考时间</td>
            <td colspan="2">11月22日 9:00-17:00</td>
          </tr>
        </table>
      </a-col>
      <a-col :span="12">
        <h3>应考人员考场守则</h3>
        <div class="rules">
          <p>
            1、为规范税务管理师CTM（初级）专业能力水平证书项目线上评定应考人员考场行为，保证评定正常有序进行，制定本守则。
          </p>
          <p>
            2、应考人员应根据准考证上的试考时间准时参加试考，并确保正式评定当天，相关评定设施设备条件与试考通过时保持一致，具体可参见《智能财务师FAI（初级）专业能力水平证书线上评定承诺书》。
          </p>
          <p>
            3、应考人员可自备签字笔、白色的空白草稿纸，不得携带其他物品，评定全程需在监控范围内可见。评定全程闭卷，不得翻阅任何与评定有关的书籍及资料。不得使用任何电子设备。
          </p>
          <p>
            4、评定开始前45分钟，应考人员应提前进入评定页面进入设备试调工作，待评定正式开始后，方可进入答题页面答题，开考30分钟后未能在评定系统登录并确认的应考人员，视为缺考，系统不再接受该准考证号登陆。评定开始60分钟后，应考人员方可交卷退出评定系统。
          </p>
          <p>
            5、应考人员评定过程中，严禁使用任何通讯工具（如耳机、手机、IPAD等），如有使用，视作弊处理。
          </p>
          <p>
            6、评定开始前，应考人员应使用准考证号码登录评定系统，登录后需仔细核对姓名、性别、准考证号、有效身份证件号及评定科目，并仔细阅读《评定须知》。应考人员如发现信息有误，应咨询在线客服人员，并听从在线客服人员的安排进行现场处理。
          </p>
          <p>
            7、评定过程中，评定机出现故障（如不能登录；中途提示网络断开等情况），可联系技术支持，严禁故意关机或自行重新启动计算机以及其它恶意操作行为，否则将判定为作弊，取消评定资格。
          </p>
          <p>8、 应考人员在评定过程中，不得自行关闭退出评定界面。</p>
          <p>
            9、应考人员须自觉遵守评定纪律，严格诚信评定，严禁评定作弊。如因疾病等原因不能坚持评定的，应报告监考人员，监考人员将根据具体情况进行处理。
          </p>
          <p>
            10、评定结束前，应考人员由于违规行为或特殊情况需提前结束评定的，应当经监考人员批准后退出评定系统。
          </p>
          <p>11、 评定结束时，系统将自动收卷，应考人员应按提示退出评定系统。</p>
          <p>
            12、所有评定的试题内容，均属于上海国家会计学院版权所有，应考人员未经授权，不得以任何方式或理由将试题内容进行抄录、复制、传播。
          </p>
          <p>
            13、应考人员如出现违规行为，将按照《智能财务师FAI专业能力评定违规违纪行为处理办法》相关规定处理。有关处理情况上海国家会计学院将在其官方网站、学习网站以公告等相关形式予以发布。
          </p>
          <p>14、 本守则自2020年1月1日起施行。</p>
        </div>
      </a-col>
    </a-row>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      type: ["身份证", "临时身份证", "护照", "港澳通行证", "台湾通行证"],
    };
  },
  props: ["isAc", "examInfo"],
  methods: {},
};
</script>

<style scoped>
section {
  position: relative;
  padding: 30px;
  background: #fff;
}
.seal {
  position: absolute;
  top: 50%;
  right: -80px;
}
h3 {
  margin-bottom: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
table {
  width: 100%;
  border: 1px solid #333;
}
tr {
  height: 47px;
}
td {
  text-align: center;
  border: 1px solid #333;
  color: #000;
}
.rules {
  padding-left: 20px;
  font-size: 12px;
  line-height: 1.5em;
  color: #000;
}
.rules p {
  margin-bottom: 5px;
}
</style>
